import { useTranslation } from "react-i18next";
import "./SwitchScheduleAnalysis.scss";
import { capitalize } from "@/shared/utils/Strings.ts";
import type { ReactNode } from "react";
import classNames from "classnames";
import useScheduleUrls from "@/pages/human-resources/time-management/schedules/site-schedule/toolbar/useScheduleUrls.ts";
import { Link } from "react-router-dom";

export type ScheduleOrAnalysis = "schedule" | "analysis";

interface Properties {
  value: ScheduleOrAnalysis;
}

export default function SwitchScheduleAnalysis(props: Properties): ReactNode {
  const { t } = useTranslation("humanResources");
  const scheduleUrls = useScheduleUrls(props.value);

  function classes(type: ScheduleOrAnalysis): string {
    return classNames(props.value === type && "selected");
  }

  return (
    <div className="switch-schedule-analysis">
      <Link
        className={classes("schedule")}
        to={scheduleUrls.toView("schedule")}
        viewTransition
      >
        {capitalize(t("timeManagement.scheduleShortName"))}
      </Link>
      <Link
        className={classes("analysis")}
        to={scheduleUrls.toView("analysis")}
        viewTransition
      >
        {capitalize(t("common.analysis", { count: 2 }))}
      </Link>
    </div>
  );
}
